
// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Grid,
//   Card,
//   CardMedia,
//   CardContent,
//   Typography,
//   Button,
//   useMediaQuery,
//   CircularProgress,
//   Snackbar,
//   Alert,
//   Pagination,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Divider,
//   Chip,
//   TextField,
//   Autocomplete,
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import { useSelector } from 'react-redux';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import { useLocation, useNavigate } from 'react-router-dom';
// import BedIcon from '@mui/icons-material/Bed';
// import BathtubIcon from '@mui/icons-material/Bathtub';
// import SquareFootIcon from '@mui/icons-material/SquareFoot';
// import RestartAltIcon from '@mui/icons-material/RestartAlt';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
// import axios from 'axios';

// const PropertyListingPage = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const isLoggedIn = useSelector(state => state.user.isAuthenticated);
//   const userData = useSelector(state => state.user.user);
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [properties, setProperties] = useState([]);
//   const [similarProperties, setSimilarProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [favoriteLoading, setFavoriteLoading] = useState({});
//   const [favoriteProperties, setFavoriteProperties] = useState([]);
//   const [showSimilar, setShowSimilar] = useState(false);
//   const [similarReason, setSimilarReason] = useState('');

//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [limit, setLimit] = useState(12);
//   const [totalProperties, setTotalProperties] = useState(0);

//   const [propertyType, setPropertyType] = useState('');
//   const [category, setCategory] = useState('all');
//   const [city, setCity] = useState('');
//   const [areaName, setAreaName] = useState('');
//   const [assetType, setAssetType] = useState('');
//   const [bhk, setBhk] = useState('');
//   const [furnishType, setFurnishType] = useState('');
  
//   const [minPrice, setMinPrice] = useState('');
//   const [maxPrice, setMaxPrice] = useState('');

//   const [filtersInitialized, setFiltersInitialized] = useState(false);

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: '',
//     severity: 'success'
//   });

//   const minPriceOptions = [
//     { label: '0', value: '0' },
//     { label: '1 Lakh', value: '100000' },
//     { label: '5 Lakhs', value: '500000' },
//     { label: '10 Lakhs', value: '1000000' },
//     { label: '20 Lakhs', value: '2000000' },
//     { label: '30 Lakhs', value: '3000000' },
//     { label: '40 Lakhs', value: '4000000' },
//     { label: '50 Lakhs', value: '5000000' },
//     { label: '60 Lakhs', value: '6000000' },
//     { label: '70 Lakhs', value: '7000000' },
//     { label: '80 Lakhs', value: '8000000' },
//     { label: '90 Lakhs', value: '9000000' },
//     { label: '1 Crore', value: '10000000' },
//     { label: '10 Crore', value: '100000000' },
//     { label: '20 Crore', value: '200000000' },
//     { label: '30 Crore', value: '300000000' },
//     { label: '40 Crore', value: '400000000' },
//     { label: '50 Crore', value: '500000000' },
//     { label: '60 Crore', value: '600000000' },
//     { label: '70 Crore', value: '700000000' },
//     { label: '80 Crore', value: '800000000' },
//     { label: '90 Crore', value: '900000000' },
//   ];

//   const maxPriceOptions = [
//     { label: '1 Lakh', value: '100000' },
//     { label: '5 Lakhs', value: '500000' },
//     { label: '10 Lakhs', value: '1000000' },
//     { label: '20 Lakhs', value: '2000000' },
//     { label: '30 Lakhs', value: '3000000' },
//     { label: '40 Lakhs', value: '4000000' },
//     { label: '50 Lakhs', value: '5000000' },
//     { label: '60 Lakhs', value: '6000000' },
//     { label: '70 Lakhs', value: '7000000' },
//     { label: '80 Lakhs', value: '8000000' },
//     { label: '90 Lakhs', value: '9000000' },
//     { label: '1 Crore', value: '10000000' },
//     { label: '10 Crore', value: '100000000' },
//     { label: '20 Crore', value: '200000000' },
//     { label: '30 Crore', value: '300000000' },
//     { label: '40 Crore', value: '400000000' },
//     { label: '50 Crore', value: '500000000' },
//     { label: '60 Crore', value: '600000000' },
//     { label: '70 Crore', value: '700000000' },
//     { label: '80 Crore', value: '800000000' },
//     { label: '90 Crore', value: '900000000' },
//     { label: '100 Crore', value: '1000000000' },
//   ];

//   const shouldHideBhkAndFurnish = () => {
//     if (!assetType) return false;

//     const commercialAssetsWithoutFilters = [
//       'Office',
//       'Showroom',
//       'Retail Shop',
//       'Warehouse',
//       'Commercial Plot'
//     ];

//     const residentialAssetsWithoutFilters = [
//       'Plot',
//       'Agriculture Land'
//     ];

//     if (commercialAssetsWithoutFilters.includes(assetType)) {
//       return true;
//     }

//     if (residentialAssetsWithoutFilters.includes(assetType)) {
//       return true;
//     }

//     return false;
//   };

//   const getStatusBadge = (status) => {
//     switch (status) {
//       case 'under_verification':
//         return {
//           text: 'Featured',
//           backgroundColor: '#f7931e',
//           show: true
//         };
//       case 'approved':
//         return {
//           text: 'Approved',
//           backgroundColor: '#4caf50',
//           show: true
//         };
//       case 'rejected':
//         return {
//           text: 'Rejected',
//           backgroundColor: '#f44336',
//           show: true
//         };
//       default:
//         return {
//           text: '',
//           backgroundColor: '',
//           show: false
//         };
//     }
//   };

//   // ✅ Function to get user-friendly error message
//   const getUserFriendlyErrorMessage = (error) => {
//     const errorString = error.toString().toLowerCase();
    
//     if (errorString.includes('fetch') || 
//         errorString.includes('network') || 
//         errorString.includes('failed to fetch') ||
//         errorString.includes('networkerror') ||
//         errorString.includes('connection')) {
//       return 'Unable to load the properties. Please check your internet connection and try again.';
//     }
    
//     if (errorString.includes('timeout')) {
//       return 'Unable to load the properties. Please check your internet connection and try again.';
//     }
    
//     if (errorString.includes('500') || errorString.includes('server error')) {
//       return 'Unable to load the properties. Please check your internet connection and try again.';
//     }
    
//     if (errorString.includes('404') || errorString.includes('not found')) {
//       return 'Unable to load the properties. Please check your internet connection and try again.';
//     }
    
//     return 'Unable to load the properties. Please check your internet connection and try again.';
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   const showSnackbar = (message, severity = 'success') => {
//     setSnackbar({
//       open: true,
//       message,
//       severity
//     });
//   };

//   const handlePageChange = (event, newPage) => {
//     setPage(newPage);
//     window.scrollTo(0, 0);
//   };

//   const isValidValue = (value) => {
//     return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
//   };

//   const hasValidImage = (base64) => {
//     return base64 && base64.length > 100 && base64 !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N19fFRV/sbxz52aNqSHEkoSblelaKKApYsGNby461rXva46tpiXqHUNAAAAAASUVORK5CYII=";
//   };

//   const getTimeAgo = (dateString) => {
//     if (!dateString) return '';
    
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffInSeconds = Math.floor((now - date) / 1000);
    
//     const intervals = {
//       y: 31536000,
//       mo: 2592000,
//       w: 604800,
//       d: 86400,
//       h: 3600,
//       m: 60,
//       s: 1
//     };
    
//     for (const [key, value] of Object.entries(intervals)) {
//       const interval = Math.floor(diffInSeconds / value);
//       if (interval >= 1) {
//         return `${interval}${key} ago`;
//       }
//     }
    
//     return 'just now';
//   };

//   useEffect(() => {
//     const fetchFavorites = async () => {
//       if (!isLoggedIn || !userData?.id) {
//         setFavoriteProperties([]);
//         return;
//       }

//       try {
//         const response = await fetch(
//           `https://propertydealstalk.com/api/buyer/getFavoritesByBuyerId?buyer_id=${userData.id}`
//         );
//         const data = await response.json();

//         if (data.statusCode === 200 && data.result) {
//           const favorites = Array.isArray(data.result) ? data.result : [];
//           const favoriteIds = favorites.map(
//             fav => fav.property?.id || fav.property_id
//           ).filter(id => id);
//           setFavoriteProperties(favoriteIds);
//           console.log('✅ Favorites loaded:', favoriteIds);
//         }
//       } catch (err) {
//         console.error('Error fetching favorites:', err);
//       }
//     };

//     fetchFavorites();
//   }, [isLoggedIn, userData?.id]);

//   useEffect(() => {
//     const queryParams = new URLSearchParams(location.search);
    
//     const urlPropertyType = queryParams.get('property_type') || '';
//     const urlCategory = queryParams.get('category') || 'all';
//     const urlCity = queryParams.get('city') || '';
//     const urlAreaName = queryParams.get('area_name') || '';
//     const urlAssetType = queryParams.get('asset_type') || '';
//     const urlBhk = queryParams.get('bhk') || '';
//     const urlFurnishType = queryParams.get('furnish_type') || '';
//     const urlMinPrice = queryParams.get('min_price') || '';
//     const urlMaxPrice = queryParams.get('max_price') || '';

//     console.log('Initializing filters from URL:', {
//       city: urlCity,
//       area_name: urlAreaName,
//       category: urlCategory,
//       property_type: urlPropertyType,
//       min_price: urlMinPrice,
//       max_price: urlMaxPrice
//     });

//     setPropertyType(urlPropertyType);
//     setCategory(urlCategory);
//     setCity(urlCity);
//     setAreaName(urlAreaName);
//     setAssetType(urlAssetType);
//     setBhk(urlBhk);
//     setFurnishType(urlFurnishType);
//     setMinPrice(urlMinPrice);
//     setMaxPrice(urlMaxPrice);
//     setPage(1);
    
//     setFiltersInitialized(true);
//   }, [location.search]);

//   useEffect(() => {
//     if (!filtersInitialized) {
//       return;
//     }

//     const fetchProperties = async () => {
//       try {
//         setLoading(true);
//         setError(null);
        
//         const apiUrl = 'https://propertydealstalk.com/api/property/filterProperties';
//         const queryParams = new URLSearchParams();

//         if (propertyType) queryParams.set('property_type', propertyType);
//         if (category && category !== 'all') queryParams.set('category', category);
//         if (city && city.trim() !== '') queryParams.set('city', city.trim());
//         if (areaName && areaName.trim() !== '') queryParams.set('area_name', areaName.trim());
//         if (assetType) queryParams.set('asset_type', assetType);
//         if (bhk) queryParams.set('bhk', bhk);
//         if (furnishType) queryParams.set('furnish_type', furnishType);
//         if (minPrice) queryParams.set('min_price', minPrice);
//         if (maxPrice) queryParams.set('max_price', maxPrice);
//         queryParams.set('page', page.toString());
//         queryParams.set('limit', limit.toString());

//         const url = `${apiUrl}?${queryParams.toString()}`;

//         console.log('Fetching properties from:', url);
//         console.log('Current filter states:', { city, areaName, category, propertyType, minPrice, maxPrice });

//         const response = await fetch(url);

//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         const data = await response.json();
//         console.log('API Response:', data);

//         if (data.statusCode === 200) {
//           let mainProperties = data.result.properties || [];
//           const similarProps = data.result.similar_properties || [];
          
//           mainProperties = mainProperties.sort((a, b) => {
//             const dateA = new Date(a.createdAt);
//             const dateB = new Date(b.createdAt);
//             return dateB - dateA;
//           });
          
//           setProperties(mainProperties);
//           setSimilarProperties(similarProps);
//           setShowSimilar(data.result.show_similar || false);
//           setSimilarReason(data.result.similar_reason || '');
//           setTotalPages(data.result.total_pages || 1);
//           setTotalProperties(data.result.total || 0);

//           console.log(`Found ${mainProperties.length} main properties, ${similarProps.length} similar properties`);

//           if (mainProperties.length > 0) {
//             showSnackbar(`Found ${data.result.total} properties`);
//           } else if (similarProps.length > 0) {
//             showSnackbar(`No exact matches. Showing ${similarProps.length} similar properties`, 'info');
//           } else {
//             showSnackbar('No properties found matching your criteria', 'info');
//           }
//         } else {
//           throw new Error('Unable to load properties');
//         }
//       } catch (err) {
//         console.error('Error fetching properties:', err);
//         const friendlyMessage = getUserFriendlyErrorMessage(err);
//         setError(friendlyMessage);
//         showSnackbar(friendlyMessage, 'error');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProperties();
//   }, [filtersInitialized, city, areaName, propertyType, category, assetType, bhk, furnishType, minPrice, maxPrice, page, limit]);

//   const handleFilterChange = () => {
//     setPage(1);
    
//     const params = new URLSearchParams();
//     if (propertyType) params.set('property_type', propertyType);
//     if (category && category !== 'all') params.set('category', category);
//     if (city && city.trim() !== '') params.set('city', city.trim());
//     if (areaName && areaName.trim() !== '') params.set('area_name', areaName.trim());
//     if (assetType) params.set('asset_type', assetType);
//     if (bhk) params.set('bhk', bhk);
//     if (furnishType) params.set('furnish_type', furnishType);
//     if (minPrice) params.set('min_price', minPrice);
//     if (maxPrice) params.set('max_price', maxPrice);
    
//     console.log('Updating URL with params:', params.toString());
    
//     navigate({
//       pathname: '/property',
//       search: params.toString()
//     }, { replace: true });
//   };

//   const handleReset = () => {
//     setPropertyType('');
//     setCategory('all');
//     setCity('');
//     setAreaName('');
//     setAssetType('');
//     setBhk('');
//     setFurnishType('');
//     setMinPrice('');
//     setMaxPrice('');
//     setPage(1);
//     navigate('/property', { replace: true });
//   };

//   const toggleFavorite = async (propertyId, e) => {
//     e.stopPropagation();
    
//     if (!isLoggedIn || !userData) {
//       showSnackbar("Please log in to manage favorites", "warning");
//       navigate('/login');
//       return;
//     }

//     const isFav = favoriteProperties.includes(propertyId);

//     try {
//       setFavoriteLoading(prev => ({ ...prev, [propertyId]: true }));
//       const buyerId = userData.id;

//       if (!buyerId) {
//         console.error('Buyer ID not found in user data');
//         showSnackbar("User information missing. Please log in again.", "error");
//         return;
//       }

//       if (isFav) {
//         console.log('Removing from favorites with buyer_id:', buyerId, 'property_id:', propertyId);

//         const response = await fetch('https://www.propertydealstalk.com/api/buyer/removeFavorite', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             buyer_id: buyerId,
//             property_id: propertyId
//           }),
//         });

//         const data = await response.json();

//         if (data.statusCode === 200) {
//           console.log('Property removed from favorites:', data.result);
//           setFavoriteProperties(prev => prev.filter(id => id !== propertyId));
//           showSnackbar("Property removed from favorites!");
//         } else {
//           console.error('Failed to remove from favorites:', data.message);
//           showSnackbar(`Failed to remove from favorites: ${data.message}`, "error");
//         }
//       } else {
//         console.log('Adding to favorites with buyer_id:', buyerId, 'property_id:', propertyId);

//         const response = await fetch('https://propertydealstalk.com/api/buyer/addFavorites', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             buyer_id: buyerId,
//             property_id: propertyId
//           }),
//         });

//         const data = await response.json();

//         if (data.statusCode === 200) {
//           console.log('Property added to favorites:', data.result);
//           setFavoriteProperties(prev => [...prev, propertyId]);
//           showSnackbar("Property added to favorites!");
//         } else {
//           console.error('Failed to add to favorites:', data.message);
//           showSnackbar(`Failed to add to favorites: ${data.message}`, "error");
//         }
//       }
//     } catch (err) {
//       console.error('Error toggling favorite:', err);
//       showSnackbar(`Error updating favorites: ${err.message}`, "error");
//     } finally {
//       setFavoriteLoading(prev => ({ ...prev, [propertyId]: false }));
//     }
//   };

//   const recordPropertyView = async (propertyId) => {
//     if (!isLoggedIn || !userData) {
//       console.log('User not logged in, skipping view recording');
//       return;
//     }

//     try {
//       const userId = userData.id;
//       if (!userId) {
//         console.error('User ID not found in user data');
//         return;
//       }

//       console.log('Recording property view with user_id:', userId, 'property_id:', propertyId);

//       const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           property_id: propertyId
//         }),
//       });

//       const data = await response.json();

//       if (data.statusCode === 200) {
//         console.log('Property view recorded successfully:', data.result);
//       } else {
//         console.error('Failed to record property view:', data.message);
//       }
//     } catch (err) {
//       console.error('Error recording property view:', err);
//     }
//   };

//   const handlePropertyClick = (propertyId) => {
//     recordPropertyView(propertyId);
//     const currentSearch = location.search;
//     navigate(`/view/${propertyId}`, { state: { from: `/property${currentSearch}` } });
//   };

//   const getImageSrc = (property) => {
//     try {
//       if (property.image && hasValidImage(property.image)) {
//         return `data:image/jpeg;base64,${property.image}`;
//       }
//       if (property.images && typeof property.images === 'object' && property.images.image && hasValidImage(property.images.image)) {
//         return `data:image/jpeg;base64,${property.images.image}`;
//       }
//       if (property.images && Array.isArray(property.images) && property.images.length > 0) {
//         const firstImage = property.images[0];
//         if (firstImage && typeof firstImage === 'object' && firstImage.image && hasValidImage(firstImage.image)) {
//           return `data:image/jpeg;base64,${firstImage.image}`;
//         }
//       }
//       return null;
//     } catch (error) {
//       console.error("Error processing image:", error);
//       return null;
//     }
//   };

//   const formatCurrency = (amount, currency = '₹') => {
//     if (!amount) return 'Price on request';
//     return `${currency}${amount.toLocaleString('en-IN')}`;
//   };

//   const isFavorite = (propertyId) => {
//     return favoriteProperties.includes(propertyId);
//   };

//   const getPropertyAmenities = (property) => {
//     const amenities = [];

//     if (isValidValue(property.bhk)) {
//       amenities.push({
//         icon: <BedIcon sx={{ color: '#666', fontSize: 18 }} />,
//         value: `${property.bhk} BHK`
//       });
//     }

//     if (isValidValue(property.bathrooms)) {
//       amenities.push({
//         icon: <BathtubIcon sx={{ color: '#666', fontSize: 18 }} />,
//         value: `${property.bathrooms} Bath`
//       });
//     }

//     if (isValidValue(property.property_size)) {
//       const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
//       amenities.push({
//         icon: <SquareFootIcon sx={{ color: '#666', fontSize: 18 }} />,
//         value: `${property.property_size} ${sizeUnit}`
//       });
//     }

//     return amenities;
//   };

//   const getActiveFilters = () => {
//     const filters = [];
//     if (propertyType) filters.push({ label: 'Property Type', value: propertyType === 'residential' ? 'Residential' : 'Commercial' });
//     if (assetType) filters.push({ label: 'Asset', value: assetType });
    
//     if (!shouldHideBhkAndFurnish()) {
//       if (bhk) filters.push({ label: 'BHK', value: `${bhk} BHK` });
//       if (furnishType) filters.push({ label: 'Furnish', value: furnishType });
//     }
    
//     if (minPrice || maxPrice) {
//       const minLabel = minPrice ? minPriceOptions.find(p => p.value === minPrice)?.label || `₹${parseInt(minPrice).toLocaleString('en-IN')}` : '0';
//       const maxLabel = maxPrice ? maxPriceOptions.find(p => p.value === maxPrice)?.label || `₹${parseInt(maxPrice).toLocaleString('en-IN')}` : '∞';
//       filters.push({ label: 'Price', value: `${minLabel} - ${maxLabel}` });
//     }
//     return filters;
//   };

//   const handleRemoveFilter = (filterLabel) => {
//     switch (filterLabel) {
//       case 'Property Type':
//         setPropertyType('');
//         setTimeout(() => handleFilterChange(), 0);
//         break;
//       case 'Asset':
//         setAssetType('');
//         setTimeout(() => handleFilterChange(), 0);
//         break;
//       case 'BHK':
//         setBhk('');
//         setTimeout(() => handleFilterChange(), 0);
//         break;
//       case 'Furnish':
//         setFurnishType('');
//         setTimeout(() => handleFilterChange(), 0);
//         break;
//       case 'Price':
//         setMinPrice('');
//         setMaxPrice('');
//         setTimeout(() => handleFilterChange(), 0);
//         break;
//       default:
//         break;
//     }
//   };

//   return (
//     <Box
//       sx={{
//         backgroundColor: '#fff',
//         fontFamily: 'Outfit',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//       }}
//     >
//       {/* Filter Section Below Navbar */}
//       <Box
//         sx={{
//           backgroundColor: '#e8e8e8',
//           mt: 1.5,
//           px: 0.25,
//           py: 1.5,
//           width: '100%',
//           borderBottom: '1px solid #d0d0d0',
//         }}
//       >
//         <Box
//           sx={{
//             maxWidth: '1440px',
//             mx: 'auto',
//             px: 2,
//           }}
//         >
//           <Box
//             sx={{
//               display: 'flex',
//               flexDirection: isMobile ? 'column' : 'row',
//               gap: 0.25,
//               alignItems: isMobile ? 'stretch' : 'center',
//             }}
//           >
//             <Box
//               sx={{
//                 display: isMobile ? 'grid' : 'flex',
//                 gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'none',
//                 gap: 0.25,
//                 flexWrap: 'wrap',
//               }}
//             >
//               <FormControl 
//                 size="small" 
//                 sx={{ 
//                   minWidth: isMobile ? 'auto' : 140,
//                   '& .MuiOutlinedInput-root': {
//                     backgroundColor: '#fff',
//                   }
//                 }}
//               >
//                 <InputLabel>Property Type</InputLabel>
//                 <Select
//                   value={propertyType}
//                   onChange={(e) => { 
//                     setPropertyType(e.target.value);
//                     setTimeout(() => handleFilterChange(), 0);
//                   }}
//                   label="Property Type"
//                 >
//                   <MenuItem value="">All</MenuItem>
//                   <MenuItem value="residential">Residential</MenuItem>
//                   <MenuItem value="commercial">Commercial</MenuItem>
//                 </Select>
//               </FormControl>

//               <FormControl 
//                 size="small" 
//                 sx={{ 
//                   minWidth: isMobile ? 'auto' : 160,
//                   '& .MuiOutlinedInput-root': {
//                     backgroundColor: '#fff',
//                   }
//                 }}
//               >
//                 <InputLabel>Asset Type</InputLabel>
//                 <Select
//                   value={assetType}
//                   onChange={(e) => { 
//                     const newValue = e.target.value;
//                     setAssetType(newValue);
                    
//                     const tempAssetType = newValue;
//                     const commercialAssetsWithoutFilters = [
//                       'Office',
//                       'Showroom',
//                       'Retail Shop',
//                       'Warehouse',
//                       'Commercial Plot'
//                     ];
//                     const residentialAssetsWithoutFilters = [
//                       'Plot',
//                       'Agriculture Land'
//                     ];
                    
//                     if (commercialAssetsWithoutFilters.includes(tempAssetType) || 
//                         residentialAssetsWithoutFilters.includes(tempAssetType)) {
//                       setBhk('');
//                       setFurnishType('');
//                     }
                    
//                                         const params = new URLSearchParams(location.search);
//                     if (propertyType) params.set('property_type', propertyType);
//                     if (category && category !== 'all') params.set('category', category);
//                     if (city && city.trim() !== '') params.set('city', city.trim());
//                     if (areaName && areaName.trim() !== '') params.set('area_name', areaName.trim());
                    
//                     if (newValue) {
//                       params.set('asset_type', newValue);
//                     } else {
//                       params.delete('asset_type');
//                     }
                    
//                     if (!(commercialAssetsWithoutFilters.includes(tempAssetType) || 
//                           residentialAssetsWithoutFilters.includes(tempAssetType))) {
//                       if (bhk) params.set('bhk', bhk);
//                       if (furnishType) params.set('furnish_type', furnishType);
//                     } else {
//                       params.delete('bhk');
//                       params.delete('furnish_type');
//                     }
                    
//                     if (minPrice) params.set('min_price', minPrice);
//                     if (maxPrice) params.set('max_price', maxPrice);
                    
//                     navigate({
//                       pathname: '/property',
//                       search: params.toString()
//                     }, { replace: true });
//                   }}
//                   label="Asset Type"
//                 >
//                   <MenuItem value="">All Assets</MenuItem>
                  
//                   <MenuItem disabled sx={{ fontWeight: 600, color: '#1976d2', fontSize: '12px' }}>
//                     RESIDENTIAL
//                   </MenuItem>
//                   <MenuItem value="Apartment">Apartment</MenuItem>
//                   <MenuItem value="Independent House">Independent House</MenuItem>
//                   <MenuItem value="Pent House">Pent House</MenuItem>
//                   <MenuItem value="Studio">Studio</MenuItem>
//                   <MenuItem value="Villa">Villa</MenuItem>
//                   <MenuItem value="Plot">Plot (Residential)</MenuItem>
//                   <MenuItem value="Agriculture Land">Agriculture Land</MenuItem>
//                   <MenuItem value="Farm House">Farm House (Residential)</MenuItem>
                  
//                   <MenuItem disabled sx={{ fontWeight: 600, color: '#1976d2', fontSize: '12px', mt: 1 }}>
//                     COMMERCIAL
//                   </MenuItem>
//                   <MenuItem value="Office">Office</MenuItem>
//                   <MenuItem value="Showroom">Showroom</MenuItem>
//                   <MenuItem value="Retail Shop">Retail Shop</MenuItem>
//                   <MenuItem value="Warehouse">Warehouse</MenuItem>
//                   <MenuItem value="Commercial Plot">Plot (Commercial)</MenuItem>
//                   <MenuItem value="Commercial Farm House">Farm House (Commercial)</MenuItem>
//                 </Select>
//               </FormControl>

//               {!shouldHideBhkAndFurnish() && (
//                 <FormControl 
//                   size="small" 
//                   sx={{ 
//                     minWidth: isMobile ? 'auto' : 120,
//                     '& .MuiOutlinedInput-root': {
//                       backgroundColor: '#fff',
//                     }
//                   }}
//                 >
//                   <InputLabel>BHK</InputLabel>
//                   <Select
//                     value={bhk}
//                     onChange={(e) => { 
//                       const newValue = e.target.value;
//                       setBhk(newValue);
                      
//                       const params = new URLSearchParams(location.search);
//                       if (propertyType) params.set('property_type', propertyType);
//                       if (category && category !== 'all') params.set('category', category);
//                       if (city && city.trim() !== '') params.set('city', city.trim());
//                       if (areaName && areaName.trim() !== '') params.set('area_name', areaName.trim());
//                       if (assetType) params.set('asset_type', assetType);
                      
//                       if (newValue) {
//                         params.set('bhk', newValue);
//                       } else {
//                         params.delete('bhk');
//                       }
                      
//                       if (furnishType) params.set('furnish_type', furnishType);
//                       if (minPrice) params.set('min_price', minPrice);
//                       if (maxPrice) params.set('max_price', maxPrice);
                      
//                       navigate({
//                         pathname: '/property',
//                         search: params.toString()
//                       }, { replace: true });
//                     }}
//                     label="BHK"
//                   >
//                     <MenuItem value="">Any</MenuItem>
//                     <MenuItem value="1">1 BHK</MenuItem>
//                     <MenuItem value="2">2 BHK</MenuItem>
//                     <MenuItem value="3">3 BHK</MenuItem>
//                     <MenuItem value="4">4 BHK</MenuItem>
//                     <MenuItem value="5">5 BHK</MenuItem>
//                     <MenuItem value="6">6 BHK</MenuItem>
//                     <MenuItem value="6+">6+ BHK</MenuItem>
//                   </Select>
//                 </FormControl>
//               )}

//               {!shouldHideBhkAndFurnish() && (
//                 <FormControl 
//                   size="small" 
//                   sx={{ 
//                     minWidth: isMobile ? 'auto' : 160,
//                     '& .MuiOutlinedInput-root': {
//                       backgroundColor: '#fff',
//                     }
//                   }}
//                 >
//                   <InputLabel>Furnish Type</InputLabel>
//                   <Select
//                     value={furnishType}
//                     onChange={(e) => { 
//                       setFurnishType(e.target.value); 
//                       setTimeout(() => handleFilterChange(), 0);
//                     }}
//                     label="Furnish Type"
//                   >
//                     <MenuItem value="">Any</MenuItem>
//                     <MenuItem value="fully">Fully Furnished</MenuItem>
//                     <MenuItem value="semi">Semi Furnished</MenuItem>
//                     <MenuItem value="unfurnished">Unfurnished</MenuItem>
//                   </Select>
//                 </FormControl>
//               )}

//               <Autocomplete
//                 freeSolo
//                 size="small"
//                 options={minPriceOptions}
//                 getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
//                 value={minPriceOptions.find(p => p.value === minPrice) || null}
//                 inputValue={minPrice ? (minPriceOptions.find(p => p.value === minPrice)?.label || minPrice) : ''}
//                 onInputChange={(event, newInputValue) => {
//                   const numericValue = newInputValue.replace(/[^0-9]/g, '');
//                   setMinPrice(numericValue);
//                 }}
//                 onChange={(event, newValue) => {
//                   if (newValue && typeof newValue === 'object') {
//                     setMinPrice(newValue.value);
//                     setTimeout(() => handleFilterChange(), 0);
//                   }
//                 }}
//                 onBlur={() => {
//                   setTimeout(() => handleFilterChange(), 0);
//                 }}
//                 sx={{
//                   minWidth: isMobile ? 'auto' : 140,
//                   '& .MuiOutlinedInput-root': {
//                     backgroundColor: '#fff',
//                   }
//                 }}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label="Min Price"
//                     placeholder="Enter or select"
//                   />
//                 )}
//               />

//               <Autocomplete
//                 freeSolo
//                 size="small"
//                 options={maxPriceOptions}
//                 getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
//                 value={maxPriceOptions.find(p => p.value === maxPrice) || null}
//                 inputValue={maxPrice ? (maxPriceOptions.find(p => p.value === maxPrice)?.label || maxPrice) : ''}
//                 onInputChange={(event, newInputValue) => {
//                   const numericValue = newInputValue.replace(/[^0-9]/g, '');
//                   setMaxPrice(numericValue);
//                 }}
//                 onChange={(event, newValue) => {
//                   if (newValue && typeof newValue === 'object') {
//                     setMaxPrice(newValue.value);
//                     setTimeout(() => handleFilterChange(), 0);
//                   }
//                 }}
//                 onBlur={() => {
//                   setTimeout(() => handleFilterChange(), 0);
//                 }}
//                 sx={{
//                   minWidth: isMobile ? 'auto' : 140,
//                   '& .MuiOutlinedInput-root': {
//                     backgroundColor: '#fff',
//                   }
//                 }}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label="Max Price"
//                     placeholder="Enter or select"
//                   />
//                 )}
//               />
//             </Box>

//             <Box
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 0.25,
//                 mt: isMobile ? 0.25 : 0,
//               }}
//             >
//               <Button
//                 onClick={handleReset}
//                 variant="outlined"
//                 startIcon={<RestartAltIcon />}
//                 sx={{
//                   bgcolor: '#fff',
//                   border: '1px solid #d0d0d0',
//                   color: '#333',
//                   '&:hover': {
//                     bgcolor: '#f5f5f5',
//                     border: '1px solid #d0d0d0',
//                   },
//                   textTransform: 'none',
//                   px: 2,
//                   py: 0.75,
//                   minWidth: isMobile ? 'auto' : 'auto',
//                   fontSize: '14px',
//                   flexShrink: 0,
//                 }}
//               >
//                 Reset
//               </Button>

//               {!isMobile && getActiveFilters().length > 0 && (
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     flexWrap: 'wrap',
//                     gap: 0.25,
//                     alignItems: 'center',
//                   }}
//                 >
//                   <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '13px', flexShrink: 0 }}>
//                     Active:
//                   </Typography>
//                   {getActiveFilters().map((filter, index) => (
//                     <Chip
//                       key={index}
//                       label={`${filter.label}: ${filter.value}`}
//                       onDelete={() => handleRemoveFilter(filter.label)}
//                       size="small"
//                       sx={{
//                         backgroundColor: '#fff',
//                         height: '26px',
//                         fontSize: '12px',
//                         '& .MuiChip-label': {
//                           px: 1.5,
//                         },
//                         '& .MuiChip-deleteIcon': {
//                           color: '#666',
//                           fontSize: '16px',
//                           '&:hover': {
//                             color: '#000',
//                           },
//                         },
//                       }}
//                     />
//                   ))}
//                 </Box>
//               )}
//             </Box>
//           </Box>

//           {isMobile && getActiveFilters().length > 0 && (
//             <Box
//               sx={{
//                 mt: 0.25,
//                 display: 'flex',
//                 flexWrap: 'wrap',
//                 gap: 0.25,
//                 alignItems: 'center',
//               }}
//             >
//               <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '12px', mr: 0.25 }}>
//                 Active:
//               </Typography>
//               {getActiveFilters().map((filter, index) => (
//                 <Chip
//                   key={index}
//                   label={`${filter.label}: ${filter.value}`}
//                   onDelete={() => handleRemoveFilter(filter.label)}
//                   size="small"
//                   sx={{
//                     backgroundColor: '#fff',
//                     height: '24px',
//                     fontSize: '11px',
//                     '& .MuiChip-label': {
//                       px: 1,
//                     },
//                     '& .MuiChip-deleteIcon': {
//                       color: '#666',
//                       fontSize: '14px',
//                       '&:hover': {
//                         color: '#000',
//                       },
//                     },
//                   }}
//                 />
//               ))}
//             </Box>
//           )}
//         </Box>
//       </Box>

//       {/* Main Content Area */}
//       <Box
//         sx={{
//           px: isMobile ? 2 : 4,
//           pb: 5,
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           width: '100%'
//         }}
//       >
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={3000}
//           onClose={handleCloseSnackbar}
//           anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//         >
//           <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
//             {snackbar.message}
//           </Alert>
//         </Snackbar>

//         {!loading && (properties.length > 0 || similarProperties.length > 0) && (
//           <Box sx={{ width: '100%', maxWidth: '1440px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, mt: 3 }}>
//             <Typography variant="body2" color="textSecondary">
//               Showing {totalProperties > 0 ? ((page - 1) * limit) + 1 : 0}-{Math.min(page * limit, totalProperties)} of {totalProperties} properties
//             </Typography>
//           </Box>
//         )}

//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
//             <CircularProgress />
//           </Box>
//         ) : error ? (
//           <Box 
//             sx={{ 
//               display: 'flex', 
//               flexDirection: 'column', 
//               alignItems: 'center', 
//               justifyContent: 'center',
//               p: 4,
//               textAlign: 'center',
//               minHeight: '300px'
//             }}
//           >
//             <Typography 
//               sx={{ 
//                 color: '#666',
//                 fontSize: '1.1rem',
//                 fontWeight: 500,
//                 maxWidth: '600px'
//               }}
//             >
//               {error}
//             </Typography>
//           </Box>
//         ) : properties.length === 0 && similarProperties.length === 0 ? (
//           <Box sx={{ textAlign: 'center', mt: 4 }}>
//             <Typography variant="h6">
//               No properties found matching your criteria.
//             </Typography>
//             <Typography variant="body2" color="textSecondary" mt={2}>
//               Try adjusting your search filters or reset them to see all available properties.
//             </Typography>
//           </Box>
//         ) : (
//           <>
//             {properties.length > 0 && (
//               <>
//                 <Grid
//                   container
//                   spacing={3}
//                   justifyContent="center"
//                   alignItems="stretch"
//                   sx={{
//                     maxWidth: '1440px',
//                     mx: 'auto',
//                   }}
//                 >
//                   {properties.map((property, index) => {
//                     const imageSrc = getImageSrc(property);
//                     const amenities = getPropertyAmenities(property);
//                     const timeAgo = getTimeAgo(property.createdAt);
//                     const isFav = isFavorite(property.id);
//                     const statusBadge = getStatusBadge(property.status);

//                     return (
//                       <Grid item key={property.id} xs="auto">
//                         <Card
//                           sx={{
//                             width: 340,
//                             height: 400,
//                             borderRadius: '12px',
//                             boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
//                             overflow: 'hidden',
//                             transition: 'transform 0.3s ease',
//                             display: 'flex',
//                             flexDirection: 'column',
//                             '&:hover': {
//                               transform: 'translateY(-5px)',
//                             },
//                           }}
//                         >
//                           <Box sx={{ position: 'relative', height: 180, flexShrink: 0 }}>
//                             {imageSrc ? (
//                               <CardMedia
//                                 component="img"
//                                 image={imageSrc}
//                                 alt="Property"
//                                 sx={{
//                                   width: '100%',
//                                   height: '100%',
//                                   objectFit: 'cover',
//                                 }}
//                               />
//                             ) : (
//                               <Box
//                                 sx={{
//                                   width: '100%',
//                                   height: '100%',
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   justifyContent: 'center',
//                                   backgroundColor: '#f5f5f5',
//                                   border: '1px dashed #ccc'
//                                 }}
//                               >
//                                 <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                                   No images uploaded
//                                 </Typography>
//                               </Box>
//                             )}

//                             {statusBadge.show && (
//                               <Box
//                                 sx={{
//                                   position: 'absolute',
//                                   top: 10,
//                                   left: 10,
//                                   backgroundColor: statusBadge.backgroundColor,
//                                   color: '#fff',
//                                   px: 2,
//                                   py: '2px',
//                                   borderRadius: '10px',
//                                   fontSize: '13px',
//                                   fontWeight: 500,
//                                 }}
//                               >
//                                 {statusBadge.text}
//                               </Box>
//                             )}

//                             {timeAgo && (
//                               <Box
//                                 sx={{
//                                   position: 'absolute',
//                                   bottom: 10,
//                                   right: 10,
//                                   bgcolor: 'rgba(0, 0, 0, 0.7)',
//                                   color: '#fff',
//                                   px: '8px',
//                                   py: '4px',
//                                   borderRadius: '4px',
//                                   fontSize: '11px',
//                                   fontWeight: 500,
//                                 }}
//                               >
//                                 {timeAgo}
//                               </Box>
//                             )}

//                             {isLoggedIn && (
//                               <Box
//                                 onClick={(e) => toggleFavorite(property.id, e)}
//                                 sx={{
//                                   position: 'absolute',
//                                   top: 10,
//                                   right: 10,
//                                   width: 32,
//                                   height: 32,
//                                   backgroundColor: 'rgba(255,255,255,0.9)',
//                                   borderRadius: '50%',
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   justifyContent: 'center',
//                                   boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
//                                   cursor: 'pointer',
//                                   opacity: favoriteLoading[property.id] ? 0.6 : 1,
//                                   transition: 'all 0.2s',
//                                   '&:hover': {
//                                     transform: 'scale(1.1)',
//                                     backgroundColor: 'rgba(255,255,255,1)',
//                                   },
//                                 }}
//                               >
//                                 {isFav ? (
//                                   <FavoriteIcon sx={{ color: 'red', fontSize: 20 }} />
//                                 ) : (
//                                   <FavoriteBorderIcon sx={{ color: '#666', fontSize: 20 }} />
//                                 )}
//                               </Box>
//                             )}
//                           </Box>

//                           <CardContent
//                             sx={{
//                               px: 2,
//                               pt: 2,
//                               pb: 1.5,
//                               display: 'flex',
//                               flexDirection: 'column',
//                               gap: 0.75,
//                               flexGrow: 1,
//                               overflow: 'hidden',
//                             }}
//                           >
//                             <Box
//                               sx={{
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 gap: 0.5,
//                                 minHeight: 50,
//                               }}
//                             >
//                               <Typography
//                                 sx={{
//                                   fontSize: '15px',
//                                   fontWeight: 600,
//                                   overflow: 'hidden',
//                                   textOverflow: 'ellipsis',
//                                   display: '-webkit-box',
//                                   WebkitLineClamp: 2,
//                                   WebkitBoxOrient: 'vertical',
//                                   lineHeight: 1.3,
//                                   wordBreak: 'break-word',
//                                 }}
//                               >
//                                 {property.property_name || property.asset_type || 'Property'}
//                               </Typography>

//                               <Typography
//                                 sx={{
//                                   fontSize: '13px',
//                                   fontWeight: 500,
//                                   color: '#2563EB',
//                                 }}
//                               >
//                                 {property.asking_price
//                                   ? formatCurrency(property.asking_price, property.currency)
//                                   : (property.monthly_rent
//                                     ? formatCurrency(property.monthly_rent, property.currency) + '/mo'
//                                     : 'Price on request')}
//                               </Typography>
//                             </Box>

//                             <Box
//                               sx={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: 0.75,
//                                 fontSize: '13px',
//                                 color: '#555',
//                                 minHeight: 22,
//                               }}
//                             >
//                               <LocationOnIcon fontSize="small" sx={{ color: '#666', flexShrink: 0, fontSize: 16 }} />
//                               <Typography
//                                 sx={{
//                                   fontSize: '13px',
//                                   overflow: 'hidden',
//                                   textOverflow: 'ellipsis',
//                                   whiteSpace: 'nowrap',
//                                 }}
//                               >
//                                 {property.location}, {property.area_name || ''}
//                               </Typography>
//                             </Box>

//                             {amenities.length > 0 && (
//                               <Box
//                                 sx={{
//                                   display: 'flex',
//                                   justifyContent: 'space-around',
//                                   alignItems: 'center',
//                                   mt: 0.25,
//                                   gap: 0.75,
//                                   minHeight: 28,
//                                 }}
//                               >
//                                 {amenities.map((amenity, idx) => (
//                                   <Box
//                                     key={idx}
//                                     sx={{
//                                       display: 'flex',
//                                       alignItems: 'center',
//                                       gap: 0.4,
//                                     }}
//                                   >
//                                     {amenity.icon}
//                                     <Typography
//                                       sx={{
//                                         fontSize: '12px',
//                                         color: '#666',
//                                         fontWeight: 500,
//                                       }}
//                                     >
//                                       {amenity.value}
//                                     </Typography>
//                                   </Box>
//                                 ))}
//                               </Box>
//                             )}

//                             <Button
//                               onClick={() => handlePropertyClick(property.id)}
//                               variant="contained"
//                               sx={{
//                                 mt: 'auto',
//                                 backgroundColor: '#005eff',
//                                 color: '#fff',
//                                 borderRadius: '10px',
//                                 textTransform: 'none',
//                                 fontWeight: 500,
//                                 px: 3,
//                                 py: 1,
//                                 width: '100%',
//                                 fontSize: '14px',
//                                 '&:hover': {
//                                   backgroundColor: '#004ecb',
//                                 },
//                               }}
//                             >
//                               View Property
//                             </Button>
//                           </CardContent>
//                         </Card>
//                       </Grid>
//                     );
//                   })}
//                 </Grid>

//                 {totalPages > 1 && (
//                   <Box sx={{ mt: 5, display: 'flex', justifyContent: 'center' }}>
//                     <Pagination
//                       count={totalPages}
//                       page={page}
//                       onChange={handlePageChange}
//                       color="primary"
//                       size={isMobile ? "small" : "medium"}
//                       showFirstButton
//                       showLastButton
//                     />
//                   </Box>
//                 )}
//               </>
//             )}

//             {showSimilar && similarProperties.length > 0 && (
//               <>
//                 <Divider sx={{ width: '100%', maxWidth: '1440px', my: 4 }} />
                
//                 <Box
//                   sx={{
//                     width: '100%',
//                     maxWidth: '1440px',
//                     mb: 3,
//                   }}
//                 >
//                   <Typography
//                     variant="h5"
//                     fontWeight={600}
//                     mb={1}
//                     sx={{
//                       textAlign: 'left',
//                     }}
//                   >
//                     Similar Properties You Might Like
//                   </Typography>
//                   {similarReason && (
//                     <Typography
//                       variant="body2"
//                       color="textSecondary"
//                       mb={2}
//                       sx={{
//                         textAlign: 'left',
//                       }}
//                     >
//                       {similarReason}
//                     </Typography>
//                   )}
//                 </Box>

//                 <Grid
//                   container
//                   spacing={3}
//                   justifyContent="center"
//                   alignItems="stretch"
//                   sx={{
//                     maxWidth: '1440px',
//                     mx: 'auto',
//                   }}
//                 >
//                   {similarProperties.map((property, index) => {
//                     const imageSrc = getImageSrc(property);
//                     const amenities = getPropertyAmenities(property);
//                     const timeAgo = getTimeAgo(property.createdAt);
//                     const isFav = isFavorite(property.id);

//                     return (
//                       <Grid item key={`similar-${property.id}`} xs="auto">
//                         <Card
//                           sx={{
//                             width: 340,
//                             height: 400,
//                             borderRadius: '12px',
//                             boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
//                             overflow: 'hidden',
//                             transition: 'transform 0.3s ease',
//                             display: 'flex',
//                             flexDirection: 'column',
//                             '&:hover': {
//                               transform: 'translateY(-5px)',
//                             },
//                           }}
//                         >
//                           <Box sx={{ position: 'relative', height: 180, flexShrink: 0 }}>
//                             {imageSrc ? (
//                               <CardMedia
//                                 component="img"
//                                 image={imageSrc}
//                                 alt="Property"
//                                 sx={{
//                                   width: '100%',
//                                   height: '100%',
//                                   objectFit: 'cover',
//                                 }}
//                               />
//                             ) : (
//                               <Box
//                                 sx={{
//                                   width: '100%',
//                                   height: '100%',
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   justifyContent: 'center',
//                                   backgroundColor: '#f5f5f5',
//                                   border: '1px dashed #ccc'
//                                 }}
//                               >
//                                 <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                                   No images uploaded
//                                 </Typography>
//                               </Box>
//                             )}

//                             <Box
//                               sx={{
//                                 position: 'absolute',
//                                 top: 10,
//                                 left: 10,
//                                 backgroundColor: '#4caf50',
//                                 color: '#fff',
//                                 px: 2,
//                                 py: '2px',
//                                 borderRadius: '10px',
//                                 fontSize: '13px',
//                                 fontWeight: 500,
//                               }}
//                             >
//                               Similar
//                             </Box>

//                             {timeAgo && (
//                               <Box
//                                 sx={{
//                                   position: 'absolute',
//                                   bottom: 10,
//                                   right: 10,
//                                   bgcolor: 'rgba(0, 0, 0, 0.7)',
//                                   color: '#fff',
//                                   px: '8px',
//                                   py: '4px',
//                                   borderRadius: '4px',
//                                   fontSize: '11px',
//                                   fontWeight: 500,
//                                 }}
//                               >
//                                 {timeAgo}
//                               </Box>
//                             )}

//                             {isLoggedIn && (
//                               <Box
//                                 onClick={(e) => toggleFavorite(property.id, e)}
//                                 sx={{
//                                   position: 'absolute',
//                                   top: 10,
//                                   right: 10,
//                                   width: 32,
//                                   height: 32,
//                                   backgroundColor: 'rgba(255,255,255,0.9)',
//                                   borderRadius: '50%',
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   justifyContent: 'center',
//                                   boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
//                                   cursor: 'pointer',
//                                   opacity: favoriteLoading[property.id] ? 0.6 : 1,
//                                   transition: 'all 0.2s',
//                                   '&:hover': {
//                                     transform: 'scale(1.1)',
//                                     backgroundColor: 'rgba(255,255,255,1)',
//                                   },
//                                 }}
//                               >
//                                 {isFav ? (
//                                   <FavoriteIcon sx={{ color: 'red', fontSize: 20 }} />
//                                 ) : (
//                                   <FavoriteBorderIcon sx={{ color: '#666', fontSize: 20 }} />
//                                 )}
//                               </Box>
//                             )}
//                           </Box>

//                                                     <CardContent
//                             sx={{
//                               px: 2,
//                               pt: 2,
//                               pb: 1.5,
//                               display: 'flex',
//                               flexDirection: 'column',
//                               gap: 0.75,
//                               flexGrow: 1,
//                               overflow: 'hidden',
//                             }}
//                           >
//                             <Box
//                               sx={{
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 gap: 0.5,
//                                 minHeight: 50,
//                               }}
//                             >
//                               <Typography
//                                 sx={{
//                                   fontSize: '15px',
//                                   fontWeight: 600,
//                                   overflow: 'hidden',
//                                   textOverflow: 'ellipsis',
//                                   display: '-webkit-box',
//                                   WebkitLineClamp: 2,
//                                   WebkitBoxOrient: 'vertical',
//                                   lineHeight: 1.3,
//                                   wordBreak: 'break-word',
//                                 }}
//                               >
//                                 {property.property_name || property.asset_type || 'Property'}
//                               </Typography>

//                               <Typography
//                                 sx={{
//                                   fontSize: '13px',
//                                   fontWeight: 500,
//                                   color: '#2563EB',
//                                 }}
//                               >
//                                 {property.asking_price
//                                   ? formatCurrency(property.asking_price, property.currency)
//                                   : (property.monthly_rent
//                                     ? formatCurrency(property.monthly_rent, property.currency) + '/mo'
//                                     : 'Price on request')}
//                               </Typography>
//                             </Box>

//                             <Box
//                               sx={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: 0.75,
//                                 fontSize: '13px',
//                                 color: '#555',
//                                 minHeight: 22,
//                               }}
//                             >
//                               <LocationOnIcon fontSize="small" sx={{ color: '#666', flexShrink: 0, fontSize: 16 }} />
//                               <Typography
//                                 sx={{
//                                   fontSize: '13px',
//                                   overflow: 'hidden',
//                                   textOverflow: 'ellipsis',
//                                   whiteSpace: 'nowrap',
//                                 }}
//                               >
//                                 {property.location}, {property.area_name || ''}
//                               </Typography>
//                             </Box>

//                             {amenities.length > 0 && (
//                               <Box
//                                 sx={{
//                                   display: 'flex',
//                                   justifyContent: 'space-around',
//                                   alignItems: 'center',
//                                   mt: 0.25,
//                                   gap: 0.75,
//                                   minHeight: 28,
//                                 }}
//                               >
//                                 {amenities.map((amenity, idx) => (
//                                   <Box
//                                     key={idx}
//                                     sx={{
//                                       display: 'flex',
//                                       alignItems: 'center',
//                                       gap: 0.4,
//                                     }}
//                                   >
//                                     {amenity.icon}
//                                     <Typography
//                                       sx={{
//                                         fontSize: '12px',
//                                         color: '#666',
//                                         fontWeight: 500,
//                                       }}
//                                     >
//                                       {amenity.value}
//                                     </Typography>
//                                   </Box>
//                                 ))}
//                               </Box>
//                             )}

//                             <Button
//                               onClick={() => handlePropertyClick(property.id)}
//                               variant="contained"
//                               sx={{
//                                 mt: 'auto',
//                                 backgroundColor: '#005eff',
//                                 color: '#fff',
//                                 borderRadius: '10px',
//                                 textTransform: 'none',
//                                 fontWeight: 500,
//                                 px: 3,
//                                 py: 1,
//                                 width: '100%',
//                                 fontSize: '14px',
//                                 '&:hover': {
//                                   backgroundColor: '#004ecb',
//                                 },
//                               }}
//                             >
//                               View Property
//                             </Button>
//                           </CardContent>
//                         </Card>
//                       </Grid>
//                     );
//                   })}
//                 </Grid>
//               </>
//             )}
//           </>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default PropertyListingPage;




import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  useMediaQuery,
  CircularProgress,
  Snackbar,
  Alert,
  Pagination,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider,
  Chip,
  TextField,
  Autocomplete,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useLocation, useNavigate } from 'react-router-dom';
import BedIcon from '@mui/icons-material/Bed';
import BathtubIcon from '@mui/icons-material/Bathtub';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import axios from 'axios';

const PropertyListingPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isLoggedIn = useSelector(state => state.user.isAuthenticated);
  const userData = useSelector(state => state.user.user);
  const location = useLocation();
  const navigate = useNavigate();

  const [properties, setProperties] = useState([]);
  const [similarProperties, setSimilarProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [favoriteLoading, setFavoriteLoading] = useState({});
  const [favoriteProperties, setFavoriteProperties] = useState([]);
  const [showSimilar, setShowSimilar] = useState(false);
  const [similarReason, setSimilarReason] = useState('');

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(12);
  const [totalProperties, setTotalProperties] = useState(0);

  const [propertyType, setPropertyType] = useState('');
  const [category, setCategory] = useState('all');
  const [city, setCity] = useState('');
  const [areaName, setAreaName] = useState('');
  const [assetType, setAssetType] = useState('');
  const [bhk, setBhk] = useState('');
  const [furnishType, setFurnishType] = useState('');
  
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');

  const [filtersInitialized, setFiltersInitialized] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const minPriceOptions = [
    { label: '0', value: '0' },
    { label: '1 Lakh', value: '100000' },
    { label: '5 Lakhs', value: '500000' },
    { label: '10 Lakhs', value: '1000000' },
    { label: '20 Lakhs', value: '2000000' },
    { label: '30 Lakhs', value: '3000000' },
    { label: '40 Lakhs', value: '4000000' },
    { label: '50 Lakhs', value: '5000000' },
    { label: '60 Lakhs', value: '6000000' },
    { label: '70 Lakhs', value: '7000000' },
    { label: '80 Lakhs', value: '8000000' },
    { label: '90 Lakhs', value: '9000000' },
    { label: '1 Crore', value: '10000000' },
    { label: '10 Crore', value: '100000000' },
    { label: '20 Crore', value: '200000000' },
    { label: '30 Crore', value: '300000000' },
    { label: '40 Crore', value: '400000000' },
    { label: '50 Crore', value: '500000000' },
    { label: '60 Crore', value: '600000000' },
    { label: '70 Crore', value: '700000000' },
    { label: '80 Crore', value: '800000000' },
    { label: '90 Crore', value: '900000000' },
  ];

  const maxPriceOptions = [
    { label: '1 Lakh', value: '100000' },
    { label: '5 Lakhs', value: '500000' },
    { label: '10 Lakhs', value: '1000000' },
    { label: '20 Lakhs', value: '2000000' },
    { label: '30 Lakhs', value: '3000000' },
    { label: '40 Lakhs', value: '4000000' },
    { label: '50 Lakhs', value: '5000000' },
    { label: '60 Lakhs', value: '6000000' },
    { label: '70 Lakhs', value: '7000000' },
    { label: '80 Lakhs', value: '8000000' },
    { label: '90 Lakhs', value: '9000000' },
    { label: '1 Crore', value: '10000000' },
    { label: '10 Crore', value: '100000000' },
    { label: '20 Crore', value: '200000000' },
    { label: '30 Crore', value: '300000000' },
    { label: '40 Crore', value: '400000000' },
    { label: '50 Crore', value: '500000000' },
    { label: '60 Crore', value: '600000000' },
    { label: '70 Crore', value: '700000000' },
    { label: '80 Crore', value: '800000000' },
    { label: '90 Crore', value: '900000000' },
    { label: '100 Crore', value: '1000000000' },
  ];

  // ✅ NEW: Function to get filtered asset types based on property type
  const getFilteredAssetTypes = () => {
    const residentialAssets = [
      'Apartment',
      'Independent House',
      'Pent House',
      'Studio',
      'Villa',
      'Plot',
      'Agriculture Land',
      'Farm House'
    ];

    const commercialAssets = [
      'Office',
      'Showroom',
      'Retail Shop',
      'Warehouse',
      'Commercial Plot',
      'Commercial Farm House'
    ];

    if (propertyType === 'residential') {
      return residentialAssets;
    } else if (propertyType === 'commercial') {
      return commercialAssets;
    } else {
      return [...residentialAssets, ...commercialAssets];
    }
  };

  const shouldHideBhkAndFurnish = () => {
    if (!assetType) return false;

    const commercialAssetsWithoutFilters = [
      'Office',
      'Showroom',
      'Retail Shop',
      'Warehouse',
      'Commercial Plot'
    ];

    const residentialAssetsWithoutFilters = [
      'Plot',
      'Agriculture Land'
    ];

    if (commercialAssetsWithoutFilters.includes(assetType)) {
      return true;
    }

    if (residentialAssetsWithoutFilters.includes(assetType)) {
      return true;
    }

    return false;
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'under_verification':
        return {
          text: 'Featured',
          backgroundColor: '#f7931e',
          show: true
        };
      case 'approved':
        return {
          text: 'Approved',
          backgroundColor: '#4caf50',
          show: true
        };
      case 'rejected':
        return {
          text: 'Rejected',
          backgroundColor: '#f44336',
          show: true
        };
      default:
        return {
          text: '',
          backgroundColor: '',
          show: false
        };
    }
  };

  const getUserFriendlyErrorMessage = (error) => {
    const errorString = error.toString().toLowerCase();
    
    if (errorString.includes('fetch') || 
        errorString.includes('network') || 
        errorString.includes('failed to fetch') ||
        errorString.includes('networkerror') ||
        errorString.includes('connection')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('timeout')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('500') || errorString.includes('server error')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('404') || errorString.includes('not found')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    return 'Unable to load the properties. Please check your internet connection and try again.';
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    window.scrollTo(0, 0);
  };

  const isValidValue = (value) => {
    return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
  };

  const hasValidImage = (base64) => {
    return base64 && base64.length > 100 && base64 !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N19fFRV/sbxz52aNqSHEkoSblelaKKApYsGNby461rXva46tpiXqHUNAAAAAASUVORK5CYII=";
  };

  const getTimeAgo = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    const intervals = {
      y: 31536000,
      mo: 2592000,
      w: 604800,
      d: 86400,
      h: 3600,
      m: 60,
      s: 1
    };
    
    for (const [key, value] of Object.entries(intervals)) {
      const interval = Math.floor(diffInSeconds / value);
      if (interval >= 1) {
        return `${interval}${key} ago`;
      }
    }
    
    return 'just now';
  };

  useEffect(() => {
    const fetchFavorites = async () => {
      if (!isLoggedIn || !userData?.id) {
        setFavoriteProperties([]);
        return;
      }

      try {
        const response = await fetch(
          `https://propertydealstalk.com/api/buyer/getFavoritesByBuyerId?buyer_id=${userData.id}`
        );
        const data = await response.json();

        if (data.statusCode === 200 && data.result) {
          const favorites = Array.isArray(data.result) ? data.result : [];
          const favoriteIds = favorites.map(
            fav => fav.property?.id || fav.property_id
          ).filter(id => id);
          setFavoriteProperties(favoriteIds);
          console.log('✅ Favorites loaded:', favoriteIds);
        }
      } catch (err) {
        console.error('Error fetching favorites:', err);
      }
    };

    fetchFavorites();
  }, [isLoggedIn, userData?.id]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    
    const urlPropertyType = queryParams.get('property_type') || '';
    const urlCategory = queryParams.get('category') || 'all';
    const urlCity = queryParams.get('city') || '';
    const urlAreaName = queryParams.get('area_name') || '';
    const urlAssetType = queryParams.get('asset_type') || '';
    const urlBhk = queryParams.get('bhk') || '';
    const urlFurnishType = queryParams.get('furnish_type') || '';
    const urlMinPrice = queryParams.get('min_price') || '';
    const urlMaxPrice = queryParams.get('max_price') || '';

    console.log('Initializing filters from URL:', {
      city: urlCity,
      area_name: urlAreaName,
      category: urlCategory,
      property_type: urlPropertyType,
      min_price: urlMinPrice,
      max_price: urlMaxPrice
    });

    setPropertyType(urlPropertyType);
    setCategory(urlCategory);
    setCity(urlCity);
    setAreaName(urlAreaName);
    setAssetType(urlAssetType);
    setBhk(urlBhk);
    setFurnishType(urlFurnishType);
    setMinPrice(urlMinPrice);
    setMaxPrice(urlMaxPrice);
    setPage(1);
    
    setFiltersInitialized(true);
  }, [location.search]);

  useEffect(() => {
    if (!filtersInitialized) {
      return;
    }

    const fetchProperties = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const apiUrl = 'https://propertydealstalk.com/api/property/filterProperties';
        const queryParams = new URLSearchParams();

        if (propertyType) queryParams.set('property_type', propertyType);
        if (category && category !== 'all') queryParams.set('category', category);
        if (city && city.trim() !== '') queryParams.set('city', city.trim());
        if (areaName && areaName.trim() !== '') queryParams.set('area_name', areaName.trim());
        if (assetType) queryParams.set('asset_type', assetType);
        if (bhk) queryParams.set('bhk', bhk);
        if (furnishType) queryParams.set('furnish_type', furnishType);
        if (minPrice) queryParams.set('min_price', minPrice);
        if (maxPrice) queryParams.set('max_price', maxPrice);
        queryParams.set('page', page.toString());
        queryParams.set('limit', limit.toString());

        const url = `${apiUrl}?${queryParams.toString()}`;

        console.log('Fetching properties from:', url);
        console.log('Current filter states:', { city, areaName, category, propertyType, minPrice, maxPrice });

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('API Response:', data);

        if (data.statusCode === 200) {
          let mainProperties = data.result.properties || [];
          const similarProps = data.result.similar_properties || [];
          
          mainProperties = mainProperties.sort((a, b) => {
            const dateA = new Date(a.createdAt);
            const dateB = new Date(b.createdAt);
            return dateB - dateA;
          });
          
          setProperties(mainProperties);
          setSimilarProperties(similarProps);
          setShowSimilar(data.result.show_similar || false);
          setSimilarReason(data.result.similar_reason || '');
          setTotalPages(data.result.total_pages || 1);
          setTotalProperties(data.result.total || 0);

          console.log(`Found ${mainProperties.length} main properties, ${similarProps.length} similar properties`);

          if (mainProperties.length > 0) {
            showSnackbar(`Found ${data.result.total} properties`);
          } else if (similarProps.length > 0) {
            showSnackbar(`No exact matches. Showing ${similarProps.length} similar properties`, 'info');
          } else {
            showSnackbar('No properties found matching your criteria', 'info');
          }
        } else {
          throw new Error('Unable to load properties');
        }
      } catch (err) {
        console.error('Error fetching properties:', err);
        const friendlyMessage = getUserFriendlyErrorMessage(err);
        setError(friendlyMessage);
        showSnackbar(friendlyMessage, 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, [filtersInitialized, city, areaName, propertyType, category, assetType, bhk, furnishType, minPrice, maxPrice, page, limit]);

  const handleFilterChange = () => {
    setPage(1);
    
    const params = new URLSearchParams();
    if (propertyType) params.set('property_type', propertyType);
    if (category && category !== 'all') params.set('category', category);
    if (city && city.trim() !== '') params.set('city', city.trim());
    if (areaName && areaName.trim() !== '') params.set('area_name', areaName.trim());
    if (assetType) params.set('asset_type', assetType);
    if (bhk) params.set('bhk', bhk);
    if (furnishType) params.set('furnish_type', furnishType);
    if (minPrice) params.set('min_price', minPrice);
    if (maxPrice) params.set('max_price', maxPrice);
    
    console.log('Updating URL with params:', params.toString());
    
    navigate({
      pathname: '/property',
      search: params.toString()
    }, { replace: true });
  };

  const handleReset = () => {
    setPropertyType('');
    setCategory('all');
    setCity('');
    setAreaName('');
    setAssetType('');
    setBhk('');
    setFurnishType('');
    setMinPrice('');
    setMaxPrice('');
    setPage(1);
    navigate('/property', { replace: true });
  };

  const toggleFavorite = async (propertyId, e) => {
    e.stopPropagation();
    
    if (!isLoggedIn || !userData) {
      showSnackbar("Please log in to manage favorites", "warning");
      navigate('/login');
      return;
    }

    const isFav = favoriteProperties.includes(propertyId);

    try {
      setFavoriteLoading(prev => ({ ...prev, [propertyId]: true }));
      const buyerId = userData.id;

      if (!buyerId) {
        console.error('Buyer ID not found in user data');
        showSnackbar("User information missing. Please log in again.", "error");
        return;
      }

      if (isFav) {
        console.log('Removing from favorites with buyer_id:', buyerId, 'property_id:', propertyId);

        const response = await fetch('https://www.propertydealstalk.com/api/buyer/removeFavorite', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            buyer_id: buyerId,
            property_id: propertyId
          }),
        });

        const data = await response.json();

        if (data.statusCode === 200) {
          console.log('Property removed from favorites:', data.result);
          setFavoriteProperties(prev => prev.filter(id => id !== propertyId));
          showSnackbar("Property removed from favorites!");
        } else {
          console.error('Failed to remove from favorites:', data.message);
          showSnackbar(`Failed to remove from favorites: ${data.message}`, "error");
        }
      } else {
        console.log('Adding to favorites with buyer_id:', buyerId, 'property_id:', propertyId);

        const response = await fetch('https://propertydealstalk.com/api/buyer/addFavorites', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            buyer_id: buyerId,
            property_id: propertyId
          }),
        });

        const data = await response.json();

        if (data.statusCode === 200) {
          console.log('Property added to favorites:', data.result);
          setFavoriteProperties(prev => [...prev, propertyId]);
          showSnackbar("Property added to favorites!");
        } else {
          console.error('Failed to add to favorites:', data.message);
          showSnackbar(`Failed to add to favorites: ${data.message}`, "error");
        }
      }
    } catch (err) {
      console.error('Error toggling favorite:', err);
      showSnackbar(`Error updating favorites: ${err.message}`, "error");
    } finally {
      setFavoriteLoading(prev => ({ ...prev, [propertyId]: false }));
    }
  };

  const recordPropertyView = async (propertyId) => {
    if (!isLoggedIn || !userData) {
      console.log('User not logged in, skipping view recording');
      return;
    }

    try {
      const userId = userData.id;
      if (!userId) {
        console.error('User ID not found in user data');
        return;
      }

      console.log('Recording property view with user_id:', userId, 'property_id:', propertyId);

      const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          property_id: propertyId
        }),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        console.log('Property view recorded successfully:', data.result);
      } else {
        console.error('Failed to record property view:', data.message);
      }
    } catch (err) {
      console.error('Error recording property view:', err);
    }
  };

  const handlePropertyClick = (propertyId) => {
    recordPropertyView(propertyId);
    const currentSearch = location.search;
    navigate(`/view/${propertyId}`, { state: { from: `/property${currentSearch}` } });
  };

  const getImageSrc = (property) => {
    try {
      if (property.image && hasValidImage(property.image)) {
        return `data:image/jpeg;base64,${property.image}`;
      }
      if (property.images && typeof property.images === 'object' && property.images.image && hasValidImage(property.images.image)) {
        return `data:image/jpeg;base64,${property.images.image}`;
      }
      if (property.images && Array.isArray(property.images) && property.images.length > 0) {
        const firstImage = property.images[0];
        if (firstImage && typeof firstImage === 'object' && firstImage.image && hasValidImage(firstImage.image)) {
          return `data:image/jpeg;base64,${firstImage.image}`;
        }
      }
      return null;
    } catch (error) {
      console.error("Error processing image:", error);
      return null;
    }
  };

  const formatCurrency = (amount, currency = '₹') => {
    if (!amount) return 'Price on request';
    return `${currency}${amount.toLocaleString('en-IN')}`;
  };

  const isFavorite = (propertyId) => {
    return favoriteProperties.includes(propertyId);
  };

  const getPropertyAmenities = (property) => {
    const amenities = [];

    if (isValidValue(property.bhk)) {
      amenities.push({
        icon: <BedIcon sx={{ color: '#666', fontSize: 18 }} />,
        value: `${property.bhk} BHK`
      });
    }

    if (isValidValue(property.bathrooms)) {
      amenities.push({
        icon: <BathtubIcon sx={{ color: '#666', fontSize: 18 }} />,
        value: `${property.bathrooms} Bath`
      });
    }

    if (isValidValue(property.property_size)) {
      const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
      amenities.push({
        icon: <SquareFootIcon sx={{ color: '#666', fontSize: 18 }} />,
        value: `${property.property_size} ${sizeUnit}`
      });
    }

    return amenities;
  };

  const getActiveFilters = () => {
    const filters = [];
    if (propertyType) filters.push({ label: 'Property Type', value: propertyType === 'residential' ? 'Residential' : 'Commercial' });
    if (assetType) filters.push({ label: 'Asset', value: assetType });
    
    if (!shouldHideBhkAndFurnish()) {
      if (bhk) filters.push({ label: 'BHK', value: `${bhk} BHK` });
      if (furnishType) filters.push({ label: 'Furnish', value: furnishType });
    }
    
    if (minPrice || maxPrice) {
      const minLabel = minPrice ? minPriceOptions.find(p => p.value === minPrice)?.label || `₹${parseInt(minPrice).toLocaleString('en-IN')}` : '0';
      const maxLabel = maxPrice ? maxPriceOptions.find(p => p.value === maxPrice)?.label || `₹${parseInt(maxPrice).toLocaleString('en-IN')}` : '∞';
      filters.push({ label: 'Price', value: `${minLabel} - ${maxLabel}` });
    }
    return filters;
  };

  const handleRemoveFilter = (filterLabel) => {
    switch (filterLabel) {
      case 'Property Type':
        setPropertyType('');
        setTimeout(() => handleFilterChange(), 0);
        break;
      case 'Asset':
        setAssetType('');
        setTimeout(() => handleFilterChange(), 0);
        break;
      case 'BHK':
        setBhk('');
        setTimeout(() => handleFilterChange(), 0);
        break;
      case 'Furnish':
        setFurnishType('');
        setTimeout(() => handleFilterChange(), 0);
        break;
      case 'Price':
        setMinPrice('');
        setMaxPrice('');
        setTimeout(() => handleFilterChange(), 0);
        break;
      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        fontFamily: 'Outfit',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* Filter Section Below Navbar */}
      <Box
        sx={{
  backgroundColor: '#e8e8e8',
  mt: 2, // ✅ Keep original spacing from navbar (no overlap)
  mb: 2,
  px: 0.35,
  py: 1.25, // ✅ Reduced internal padding (balanced look)
  width: '100%',
  borderBottom: '1px solid #d0d0d0',
}}


      >
        <Box
          sx={{
            maxWidth: '1440px',
            mx: 'auto',
            px: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: 0.25,
              alignItems: isMobile ? 'stretch' : 'center',
            }}
          >
            <Box
              sx={{
                display: isMobile ? 'grid' : 'flex',
                gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'none',
                gap: 0.75,
                flexWrap: 'wrap',
              }}
            >
                            {/* ✅ UPDATED: Property Type Dropdown */}
              <FormControl 
                size="small" 
                sx={{ 
                  minWidth: isMobile ? 'auto' : 140,
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#fff',
                  }
                }}
              >
                <InputLabel>Property Type</InputLabel>
                <Select
                  value={propertyType}
                  onChange={(e) => { 
                    const newPropertyType = e.target.value;
                    setPropertyType(newPropertyType);
                    
                    // ✅ Reset asset type when property type changes
                    setAssetType('');
                    
                    setTimeout(() => handleFilterChange(), 0);
                  }}
                  label="Property Type"
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="residential">Residential</MenuItem>
                  <MenuItem value="commercial">Commercial</MenuItem>
                </Select>
              </FormControl>

              {/* ✅ UPDATED: Asset Type Dropdown with Dynamic Filtering */}
<FormControl 
  size="small" 
  sx={{ 
    minWidth: isMobile ? 'auto' : 160,
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#fff',
    }
  }}
>
  <InputLabel>Asset Type</InputLabel>
  <Select
    value={assetType}
    onChange={(e) => { 
      const newValue = e.target.value;
      setAssetType(newValue);
      
      // ✅ Clear BHK and Furnish for certain asset types
      const commercialAssetsWithoutFilters = [
        'Office',
        'Showroom',
        'Retail Shop',
        'Warehouse',
        'Commercial Plot'
      ];
      const residentialAssetsWithoutFilters = [
        'Plot',
        'Agriculture Land'
      ];
      
      if (commercialAssetsWithoutFilters.includes(newValue) || 
          residentialAssetsWithoutFilters.includes(newValue)) {
        setBhk('');
        setFurnishType('');
      }
      
      // ✅ FIX: Build params directly using newValue, not state
      const params = new URLSearchParams(location.search);
      if (propertyType) params.set('property_type', propertyType);
      if (category && category !== 'all') params.set('category', category);
      if (city && city.trim() !== '') params.set('city', city.trim());
      if (areaName && areaName.trim() !== '') params.set('area_name', areaName.trim());
      
      // ✅ Use newValue directly, not assetType state
      if (newValue) {
        params.set('asset_type', newValue);
      } else {
        params.delete('asset_type');
      }
      
      // ✅ Clear BHK and Furnish from URL if needed
      if (commercialAssetsWithoutFilters.includes(newValue) || 
          residentialAssetsWithoutFilters.includes(newValue)) {
        params.delete('bhk');
        params.delete('furnish_type');
      } else {
        if (bhk) params.set('bhk', bhk);
        if (furnishType) params.set('furnish_type', furnishType);
      }
      
      if (minPrice) params.set('min_price', minPrice);
      if (maxPrice) params.set('max_price', maxPrice);
      
      navigate({
        pathname: '/property',
        search: params.toString()
      }, { replace: true });
    }}
    label="Asset Type"
  >
    <MenuItem value="">All Assets</MenuItem>
    
    {/* ✅ FIXED: Residential assets WITHOUT Fragment - using array */}
    {(propertyType === '' || propertyType === 'residential') && [
      <MenuItem key="res-header" disabled sx={{ fontWeight: 600, color: '#1976d2', fontSize: '12px' }}>
        RESIDENTIAL
      </MenuItem>,
      <MenuItem key="apartment" value="Apartment">Apartment</MenuItem>,
      <MenuItem key="house" value="Independent House">Independent House</MenuItem>,
      <MenuItem key="penthouse" value="Pent House">Pent House</MenuItem>,
      <MenuItem key="studio" value="Studio">Studio</MenuItem>,
      <MenuItem key="villa" value="Villa">Villa</MenuItem>,
      <MenuItem key="plot" value="Plot">Plot (Residential)</MenuItem>,
      <MenuItem key="agri" value="Agriculture Land">Agriculture Land</MenuItem>,
      <MenuItem key="farm" value="Farm House">Farm House (Residential)</MenuItem>
    ]}
    
    {/* ✅ FIXED: Commercial assets WITHOUT Fragment - using array */}
    {(propertyType === '' || propertyType === 'commercial') && [
      <MenuItem key="com-header" disabled sx={{ fontWeight: 600, color: '#1976d2', fontSize: '12px', mt: propertyType === '' ? 1 : 0 }}>
        COMMERCIAL
      </MenuItem>,
      <MenuItem key="office" value="Office">Office</MenuItem>,
      <MenuItem key="showroom" value="Showroom">Showroom</MenuItem>,
      <MenuItem key="retail" value="Retail Shop">Retail Shop</MenuItem>,
      <MenuItem key="warehouse" value="Warehouse">Warehouse</MenuItem>,
      <MenuItem key="com-plot" value="Commercial Plot">Plot (Commercial)</MenuItem>,
      <MenuItem key="com-farm" value="Commercial Farm House">Farm House (Commercial)</MenuItem>
    ]}
  </Select>
</FormControl>





              {!shouldHideBhkAndFurnish() && (
                <FormControl 
                  size="small" 
                  sx={{ 
                    minWidth: isMobile ? 'auto' : 120,
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#fff',
                    }
                  }}
                >
                  <InputLabel>BHK</InputLabel>
                  <Select
                    value={bhk}
                    onChange={(e) => { 
                      const newValue = e.target.value;
                      setBhk(newValue);
                      
                      const params = new URLSearchParams(location.search);
                      if (propertyType) params.set('property_type', propertyType);
                      if (category && category !== 'all') params.set('category', category);
                      if (city && city.trim() !== '') params.set('city', city.trim());
                      if (areaName && areaName.trim() !== '') params.set('area_name', areaName.trim());
                      if (assetType) params.set('asset_type', assetType);
                      
                      if (newValue) {
                        params.set('bhk', newValue);
                      } else {
                        params.delete('bhk');
                      }
                      
                      if (furnishType) params.set('furnish_type', furnishType);
                      if (minPrice) params.set('min_price', minPrice);
                      if (maxPrice) params.set('max_price', maxPrice);
                      
                      navigate({
                        pathname: '/property',
                        search: params.toString()
                      }, { replace: true });
                    }}
                    label="BHK"
                  >
                    <MenuItem value="">Any</MenuItem>
                    <MenuItem value="1">1 BHK</MenuItem>
                    <MenuItem value="2">2 BHK</MenuItem>
                    <MenuItem value="3">3 BHK</MenuItem>
                    <MenuItem value="4">4 BHK</MenuItem>
                    <MenuItem value="5">5 BHK</MenuItem>
                    <MenuItem value="6">6 BHK</MenuItem>
                    <MenuItem value="6+">6+ BHK</MenuItem>
                  </Select>
                </FormControl>
              )}

              {!shouldHideBhkAndFurnish() && (
                <FormControl 
                  size="small" 
                  sx={{ 
                    minWidth: isMobile ? 'auto' : 160,
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#fff',
                    }
                  }}
                >
                  <InputLabel>Furnish Type</InputLabel>
                  <Select
                    value={furnishType}
                    onChange={(e) => { 
                      setFurnishType(e.target.value); 
                      setTimeout(() => handleFilterChange(), 0);
                    }}
                    label="Furnish Type"
                  >
                    <MenuItem value="">Any</MenuItem>
                    <MenuItem value="fully">Fully Furnished</MenuItem>
                    <MenuItem value="semi">Semi Furnished</MenuItem>
                    <MenuItem value="unfurnished">Unfurnished</MenuItem>
                  </Select>
                </FormControl>
              )}

              <Autocomplete
                freeSolo
                size="small"
                options={minPriceOptions}
                getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
                value={minPriceOptions.find(p => p.value === minPrice) || null}
                inputValue={minPrice ? (minPriceOptions.find(p => p.value === minPrice)?.label || minPrice) : ''}
                onInputChange={(event, newInputValue) => {
                  const numericValue = newInputValue.replace(/[^0-9]/g, '');
                  setMinPrice(numericValue);
                }}
                onChange={(event, newValue) => {
                  if (newValue && typeof newValue === 'object') {
                    setMinPrice(newValue.value);
                    setTimeout(() => handleFilterChange(), 0);
                  }
                }}
                onBlur={() => {
                  setTimeout(() => handleFilterChange(), 0);
                }}
                sx={{
                  minWidth: isMobile ? 'auto' : 140,
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#fff',
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Min Price"
                    placeholder="Enter or select"
                  />
                )}
              />

              <Autocomplete
                freeSolo
                size="small"
                options={maxPriceOptions}
                getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
                value={maxPriceOptions.find(p => p.value === maxPrice) || null}
                inputValue={maxPrice ? (maxPriceOptions.find(p => p.value === maxPrice)?.label || maxPrice) : ''}
                onInputChange={(event, newInputValue) => {
                  const numericValue = newInputValue.replace(/[^0-9]/g, '');
                  setMaxPrice(numericValue);
                }}
                onChange={(event, newValue) => {
                  if (newValue && typeof newValue === 'object') {
                    setMaxPrice(newValue.value);
                    setTimeout(() => handleFilterChange(), 0);
                  }
                }}
                onBlur={() => {
                  setTimeout(() => handleFilterChange(), 0);
                }}
                sx={{
                  minWidth: isMobile ? 'auto' : 140,
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#fff',
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Max Price"
                    placeholder="Enter or select"
                  />
                )}
              />
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.25,
                mt: isMobile ? 0.25 : 0,
              }}
            >
              <Button
                onClick={handleReset}
                variant="outlined"
                startIcon={<RestartAltIcon />}
                sx={{
                  bgcolor: '#fff',
                  border: '1px solid #d0d0d0',
                  color: '#333',
                  '&:hover': {
                    bgcolor: '#f5f5f5',
                    border: '1px solid #d0d0d0',
                  },
                  textTransform: 'none',
                  px: 2,
                  py: 0.75,
                  minWidth: isMobile ? 'auto' : 'auto',
                  fontSize: '14px',
                  flexShrink: 0,
                }}
              >
                Reset
              </Button>

             {!isMobile && getActiveFilters().length > 0 && (
  <Box
    sx={{
      display: 'flex',
      gap: 0.5,
      alignItems: 'flex-start',
    }}
  >
    <Typography 
      variant="body2" 
      sx={{ 
        fontWeight: 600, 
        fontSize: '13px', 
        flexShrink: 0,
        pt: 0.375,  // ✅ Aligns "Active:" vertically with chips
      }}
    >
      Active:
    </Typography>
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
        alignItems: 'center',
      }}
    >
      {getActiveFilters().map((filter, index) => (
        <Chip
          key={index}
          label={`${filter.label}: ${filter.value}`}
          onDelete={() => handleRemoveFilter(filter.label)}
          size="small"
          sx={{
            backgroundColor: '#fff',
            height: '26px',
            fontSize: '12px',
            '& .MuiChip-label': {
              px: 1.5,
            },
            '& .MuiChip-deleteIcon': {
              color: '#666',
              fontSize: '16px',
              '&:hover': {
                color: '#000',
              },
            },
          }}
        />
      ))}
    </Box>
  </Box>
)}

            </Box>
          </Box>

          {isMobile && getActiveFilters().length > 0 && (
  <Box
    sx={{
      mt: 0.5,
      display: 'flex',
      gap: 0.5,
      alignItems: 'flex-start',
    }}
  >
    <Typography 
      variant="body2" 
      sx={{ 
        fontWeight: 600, 
        fontSize: '12px',
        flexShrink: 0,
        pt: 0.25,  // ✅ Aligns "Active:" vertically with chips
      }}
    >
      Active:
    </Typography>
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
        alignItems: 'center',
      }}
    >
      {getActiveFilters().map((filter, index) => (
        <Chip
          key={index}
          label={`${filter.label}: ${filter.value}`}
          onDelete={() => handleRemoveFilter(filter.label)}
          size="small"
          sx={{
            backgroundColor: '#fff',
            height: '24px',
            fontSize: '11px',
            '& .MuiChip-label': {
              px: 1,
            },
            '& .MuiChip-deleteIcon': {
              color: '#666',
              fontSize: '14px',
              '&:hover': {
                color: '#000',
              },
            },
          }}
        />
      ))}
    </Box>
  </Box>
)}

        </Box>
      </Box>

      {/* Main Content Area */}
      <Box
        sx={{
          px: isMobile ? 2 : 4,
          pb: 5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>

        {!loading && (properties.length > 0 || similarProperties.length > 0) && (
          <Box sx={{ width: '100%', maxWidth: '1440px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, mt: 3 }}>
            <Typography variant="body2" color="textSecondary">
              Showing {totalProperties > 0 ? ((page - 1) * limit) + 1 : 0}-{Math.min(page * limit, totalProperties)} of {totalProperties} properties
            </Typography>
          </Box>
        )}

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              justifyContent: 'center',
              p: 4,
              textAlign: 'center',
              minHeight: '300px'
            }}
          >
            <Typography 
              sx={{ 
                color: '#666',
                fontSize: '1.1rem',
                fontWeight: 500,
                maxWidth: '600px'
              }}
            >
              {error}
            </Typography>
          </Box>
        ) : properties.length === 0 && similarProperties.length === 0 ? (
          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Typography variant="h6">
              No properties found matching your criteria.
            </Typography>
            <Typography variant="body2" color="textSecondary" mt={2}>
              Try adjusting your search filters or reset them to see all available properties.
            </Typography>
          </Box>
        ) : (
          <>
            {properties.length > 0 && (
              <>
                <Grid
                  container
                  spacing={3}
                  justifyContent="center"
                  alignItems="stretch"
                  sx={{
                    maxWidth: '1440px',
                    mx: 'auto',
                  }}
                >
                  {properties.map((property, index) => {
                    const imageSrc = getImageSrc(property);
                    const amenities = getPropertyAmenities(property);
                    const timeAgo = getTimeAgo(property.createdAt);
                    const isFav = isFavorite(property.id);
                    const statusBadge = getStatusBadge(property.status);

                    return (
                      <Grid item key={property.id} xs="auto">
                        <Card
                          sx={{
                            width: 340,
                            height: 400,
                            borderRadius: '12px',
                            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                            overflow: 'hidden',
                            transition: 'transform 0.3s ease',
                            display: 'flex',
                            flexDirection: 'column',
                            '&:hover': {
                              transform: 'translateY(-5px)',
                            },
                          }}
                        >
                          <Box sx={{ position: 'relative', height: 180, flexShrink: 0 }}>
                            {imageSrc ? (
                              <CardMedia
                                component="img"
                                image={imageSrc}
                                alt="Property"
                                sx={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            ) : (
                              <Box
                                sx={{
                                  width: '100%',
                                  height: '100%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  backgroundColor: '#f5f5f5',
                                  border: '1px dashed #ccc'
                                }}
                              >
                                <Typography variant="body2" color="#888" textAlign="center" px={2}>
                                  No images uploaded
                                </Typography>
                              </Box>
                            )}

                            {statusBadge.show && (
                              <Box
                                sx={{
                                  position: 'absolute',
                                  top: 10,
                                  left: 10,
                                  backgroundColor: statusBadge.backgroundColor,
                                  color: '#fff',
                                  px: 2,
                                  py: '2px',
                                  borderRadius: '10px',
                                  fontSize: '13px',
                                  fontWeight: 500,
                                }}
                              >
                                {statusBadge.text}
                              </Box>
                            )}

                            {timeAgo && (
                              <Box
                                sx={{
                                  position: 'absolute',
                                  bottom: 10,
                                  right: 10,
                                  bgcolor: 'rgba(0, 0, 0, 0.7)',
                                  color: '#fff',
                                  px: '8px',
                                  py: '4px',
                                  borderRadius: '4px',
                                  fontSize: '11px',
                                  fontWeight: 500,
                                }}
                              >
                                {timeAgo}
                              </Box>
                            )}

                            {isLoggedIn && (
                              <Box
                                onClick={(e) => toggleFavorite(property.id, e)}
                                sx={{
                                  position: 'absolute',
                                  top: 10,
                                  right: 10,
                                  width: 32,
                                  height: 32,
                                  backgroundColor: 'rgba(255,255,255,0.9)',
                                  borderRadius: '50%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                                  cursor: 'pointer',
                                  opacity: favoriteLoading[property.id] ? 0.6 : 1,
                                  transition: 'all 0.2s',
                                  '&:hover': {
                                    transform: 'scale(1.1)',
                                    backgroundColor: 'rgba(255,255,255,1)',
                                  },
                                }}
                              >
                                {isFav ? (
                                  <FavoriteIcon sx={{ color: 'red', fontSize: 20 }} />
                                ) : (
                                  <FavoriteBorderIcon sx={{ color: '#666', fontSize: 20 }} />
                                )}
                              </Box>
                            )}
                          </Box>

                          <CardContent
                            sx={{
                              px: 2,
                              pt: 2,
                              pb: 1.5,
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 0.75,
                              flexGrow: 1,
                              overflow: 'hidden',
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 0.5,
                                minHeight: 50,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: '15px',
                                  fontWeight: 600,
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: '-webkit-box',
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: 'vertical',
                                  lineHeight: 1.3,
                                  wordBreak: 'break-word',
                                }}
                              >
                                {property.property_name || property.asset_type || 'Property'}
                              </Typography>

                              <Typography
                                sx={{
                                  fontSize: '13px',
                                  fontWeight: 500,
                                  color: '#2563EB',
                                }}
                              >
                                {property.asking_price
                                  ? formatCurrency(property.asking_price, property.currency)
                                  : (property.monthly_rent
                                    ? formatCurrency(property.monthly_rent, property.currency) + '/mo'
                                    : 'Price on request')}
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.75,
                                fontSize: '13px',
                                color: '#555',
                                minHeight: 22,
                              }}
                            >
                              <LocationOnIcon fontSize="small" sx={{ color: '#666', flexShrink: 0, fontSize: 16 }} />
                              <Typography
                                sx={{
                                  fontSize: '13px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {property.location}, {property.area_name || ''}
                              </Typography>
                            </Box>

                            {amenities.length > 0 && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-around',
                                  alignItems: 'center',
                                  mt: 0.25,
                                  gap: 0.75,
                                  minHeight: 28,
                                }}
                              >
                                {amenities.map((amenity, idx) => (
                                  <Box
                                    key={idx}
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 0.4,
                                    }}
                                  >
                                    {amenity.icon}
                                    <Typography
                                      sx={{
                                        fontSize: '12px',
                                        color: '#666',
                                        fontWeight: 500,
                                      }}
                                    >
                                      {amenity.value}
                                    </Typography>
                                  </Box>
                                ))}
                              </Box>
                            )}

                            <Button
                              onClick={() => handlePropertyClick(property.id)}
                              variant="contained"
                              sx={{
                                mt: 'auto',
                                backgroundColor: '#005eff',
                                color: '#fff',
                                borderRadius: '10px',
                                textTransform: 'none',
                                fontWeight: 500,
                                px: 3,
                                py: 1,
                                width: '100%',
                                fontSize: '14px',
                                '&:hover': {
                                  backgroundColor: '#004ecb',
                                },
                              }}
                            >
                              View Property
                            </Button>
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  })}
                </Grid>

                {totalPages > 1 && (
                  <Box sx={{ mt: 5, display: 'flex', justifyContent: 'center' }}>
                    <Pagination
                      count={totalPages}
                      page={page}
                      onChange={handlePageChange}
                      color="primary"
                      size={isMobile ? "small" : "medium"}
                      showFirstButton
                      showLastButton
                    />
                  </Box>
                )}
              </>
            )}

            {showSimilar && similarProperties.length > 0 && (
              <>
                <Divider sx={{ width: '100%', maxWidth: '1440px', my: 4 }} />
                
                <Box
                  sx={{
                    width: '100%',
                    maxWidth: '1440px',
                    mb: 3,
                  }}
                >
                  <Typography
                    variant="h5"
                    fontWeight={600}
                    mb={1}
                    sx={{
                      textAlign: 'left',
                    }}
                  >
                    Similar Properties You Might Like
                  </Typography>
                  {similarReason && (
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      mb={2}
                      sx={{
                        textAlign: 'left',
                      }}
                    >
                      {similarReason}
                    </Typography>
                  )}
                </Box>

                <Grid
                  container
                  spacing={3}
                  justifyContent="center"
                  alignItems="stretch"
                  sx={{
                    maxWidth: '1440px',
                    mx: 'auto',
                  }}
                >
                  {similarProperties.map((property, index) => {
                    const imageSrc = getImageSrc(property);
                    const amenities = getPropertyAmenities(property);
                    const timeAgo = getTimeAgo(property.createdAt);
                    const isFav = isFavorite(property.id);

                    return (
                      <Grid item key={`similar-${property.id}`} xs="auto">
                        <Card
                          sx={{
                            width: 340,
                            height: 400,
                            borderRadius: '12px',
                            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                            overflow: 'hidden',
                            transition: 'transform 0.3s ease',
                            display: 'flex',
                            flexDirection: 'column',
                            '&:hover': {
                              transform: 'translateY(-5px)',
                            },
                          }}
                        >
                          <Box sx={{ position: 'relative', height: 180, flexShrink: 0 }}>
                            {imageSrc ? (
                              <CardMedia
                                component="img"
                                image={imageSrc}
                                alt="Property"
                                sx={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                            ) : (
                              <Box
                                sx={{
                                  width: '100%',
                                  height: '100%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  backgroundColor: '#f5f5f5',
                                  border: '1px dashed #ccc'
                                }}
                              >
                                <Typography variant="body2" color="#888" textAlign="center" px={2}>
                                  No images uploaded
                                </Typography>
                              </Box>
                            )}

                                                        <Box
                              sx={{
                                position: 'absolute',
                                top: 10,
                                left: 10,
                                backgroundColor: '#4caf50',
                                color: '#fff',
                                px: 2,
                                py: '2px',
                                borderRadius: '10px',
                                fontSize: '13px',
                                fontWeight: 500,
                              }}
                            >
                              Similar
                            </Box>

                            {timeAgo && (
                              <Box
                                sx={{
                                  position: 'absolute',
                                  bottom: 10,
                                  right: 10,
                                  bgcolor: 'rgba(0, 0, 0, 0.7)',
                                  color: '#fff',
                                  px: '8px',
                                  py: '4px',
                                  borderRadius: '4px',
                                  fontSize: '11px',
                                  fontWeight: 500,
                                }}
                              >
                                {timeAgo}
                              </Box>
                            )}

                            {isLoggedIn && (
                              <Box
                                onClick={(e) => toggleFavorite(property.id, e)}
                                sx={{
                                  position: 'absolute',
                                  top: 10,
                                  right: 10,
                                  width: 32,
                                  height: 32,
                                  backgroundColor: 'rgba(255,255,255,0.9)',
                                  borderRadius: '50%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                                  cursor: 'pointer',
                                  opacity: favoriteLoading[property.id] ? 0.6 : 1,
                                  transition: 'all 0.2s',
                                  '&:hover': {
                                    transform: 'scale(1.1)',
                                    backgroundColor: 'rgba(255,255,255,1)',
                                  },
                                }}
                              >
                                {isFav ? (
                                  <FavoriteIcon sx={{ color: 'red', fontSize: 20 }} />
                                ) : (
                                  <FavoriteBorderIcon sx={{ color: '#666', fontSize: 20 }} />
                                )}
                              </Box>
                            )}
                          </Box>

                          <CardContent
                            sx={{
                              px: 2,
                              pt: 2,
                              pb: 1.5,
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 0.75,
                              flexGrow: 1,
                              overflow: 'hidden',
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 0.5,
                                minHeight: 50,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: '15px',
                                  fontWeight: 600,
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: '-webkit-box',
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: 'vertical',
                                  lineHeight: 1.3,
                                  wordBreak: 'break-word',
                                }}
                              >
                                {property.property_name || property.asset_type || 'Property'}
                              </Typography>

                              <Typography
                                sx={{
                                  fontSize: '13px',
                                  fontWeight: 500,
                                  color: '#2563EB',
                                }}
                              >
                                {property.asking_price
                                  ? formatCurrency(property.asking_price, property.currency)
                                  : (property.monthly_rent
                                    ? formatCurrency(property.monthly_rent, property.currency) + '/mo'
                                    : 'Price on request')}
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.75,
                                fontSize: '13px',
                                color: '#555',
                                minHeight: 22,
                              }}
                            >
                              <LocationOnIcon fontSize="small" sx={{ color: '#666', flexShrink: 0, fontSize: 16 }} />
                              <Typography
                                sx={{
                                  fontSize: '13px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {property.location}, {property.area_name || ''}
                              </Typography>
                            </Box>

                            {amenities.length > 0 && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-around',
                                  alignItems: 'center',
                                  mt: 0.25,
                                  gap: 0.75,
                                  minHeight: 28,
                                }}
                              >
                                {amenities.map((amenity, idx) => (
                                  <Box
                                    key={idx}
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 0.4,
                                    }}
                                  >
                                    {amenity.icon}
                                    <Typography
                                      sx={{
                                        fontSize: '12px',
                                        color: '#666',
                                        fontWeight: 500,
                                      }}
                                    >
                                      {amenity.value}
                                    </Typography>
                                  </Box>
                                ))}
                              </Box>
                            )}

                            <Button
                              onClick={() => handlePropertyClick(property.id)}
                              variant="contained"
                              sx={{
                                mt: 'auto',
                                backgroundColor: '#005eff',
                                color: '#fff',
                                borderRadius: '10px',
                                textTransform: 'none',
                                fontWeight: 500,
                                px: 3,
                                py: 1,
                                width: '100%',
                                fontSize: '14px',
                                '&:hover': {
                                  backgroundColor: '#004ecb',
                                },
                              }}
                            >
                              View Property
                            </Button>
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  })}
                </Grid>
              </>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default PropertyListingPage;

